{
  "pages": {
    "purchaseOrders": {
      "title": "Purchase orders"
    },
    "purchaseRequests": {
      "title": "Purchase requests"
    },
    "goodsReceipts": {
      "title": "Goods receipts"
    },
    "rfqs": {
      "title": "RFQs"
    },
    "quotations": {
      "title": "Quotation Comparison"
    },
    "vendorBills": {
      "title": "Vendor Bills & Payments"
    },
    "catalogs": {
      "title": "Supplier catalogs"
    },
    "contracts": {
      "title": "Contracts & reorder"
    },
    "reports": {
      "title": "Procurement reports"
    },
    "setup": {
      "title": "Procurement setup"
    },
    "vendorPortal": {
      "title": "Vendor portal",
      "loginDescription": "Supplier self-service login",
      "verifyDescription": "Verifying your login link…",
      "signInDescription": "Sign in to view RFQs, POs, and invoices",
      "welcome": "Welcome, {{supplierName}}"
    },
    "dashboard": {
      "title": "Procurement Dashboard",
      "description": "Purchase lifecycle KPIs for your company and approval scope",
      "operationalDetails": "Operational details",
      "pendingApprovals": "Pending approvals",
      "pendingGrns": "Pending GRNs",
      "stockReceiptTitle": "Stock receipt",
      "stockReceiptMessage": "Legacy /v1/purchases is retired — receive stock only via GRN post under Goods receipts."
    },
    "publishedSupplierCatalogsForDirectBuying": "Published supplier catalogs for direct buying",
    "supplierContractsAndInventoryDrivenAuto": "Supplier contracts and inventory-driven auto-reorder",
    "submitForQcApprovalThenPost": "Submit for QC approval, then post GRN to increase inventory",
    "approvedPosInventoryUpdatesOnlyOn": "Approved POs — inventory updates only on GRN post",
    "internalProductRequestsBeforeRfqAnd": "Internal product requests before RFQ and purchase order",
    "compareSupplierQuotationsByPriceDelivery": "Compare supplier quotations by price, delivery and terms before selection.",
    "exportOperationalAndSpendReports": "Export operational and spend reports",
    "requestForQuotationInviteMultipleSuppliers": "Request for quotation — invite multiple suppliers with multiple product lines",
    "approvalWorkflowsAndVendorPortalConfiguration": "Approval workflows and vendor portal configuration",
    "postVendorPaymentsWithBillAllocations": "Post vendor payments with bill allocations and payable tracking.",
    "rfqsPurchaseOrdersAndInvoiceStatus": "RFQs, purchase orders, and invoice status"
  },
  "toast": {
    "poSubmittedForApproval": "PO submitted for approval",
    "purchaseOrderCancelled": "Purchase order cancelled",
    "grnCreatedQcPending": "GRN {{grnNumber}} created — QC approve then post",
    "quotationRecorded": "Quotation recorded",
    "poCreatedSubmitApproval": "PO {{poNumber}} created — submit for approval",
    "winningQuotationSelected": "Winning quotation selected",
    "reportExported": "{{reportType}} exported",
    "loginLinkSent": "If registered, a login link was sent (check server logs in dev)",
    "vendorPortalInviteSent": "Vendor portal invite sent",
    "rfqCreatedAndSent": "RFQ created and sent to suppliers",
    "quotationSubmitted": "Quotation submitted",
    "invoiceSubmitted": "Invoice submitted",
    "signedInVendorPortal": "Signed in to vendor portal",
    "requestSubmitted": "Request {{requestNumber}} submitted",
    "requestCancelled": "Request cancelled",
    "threeWayMatchCompleted": "Three-way match completed",
    "vendorBillCreated": "Vendor bill created",
    "vendorPaymentPosted": "Vendor payment posted",
    "grnSubmittedForQc": "GRN submitted for QC approval",
    "grnCancelled": "GRN cancelled",
    "grnPosted": "GRN {{grnNumber}} posted — inventory updated",
    "autoReorderCreated": "Auto-reorder created {{count}} purchase request(s)"
  },
  "errors": {
    "submitFailed": "Submit failed",
    "cancelFailed": "Cancel failed",
    "poNoLineItems": "PO has no line items",
    "createGrnFailed": "Create GRN failed",
    "loadQuotationComparisonFailed": "Failed to load quotation comparison",
    "selectRfqFirst": "Select an RFQ first",
    "selectSupplier": "Select a supplier",
    "addQuotedLineRequired": "Add at least one quoted product line with unit price",
    "recordQuotationFailed": "Record quotation failed",
    "selectStoreFirst": "Select a store first",
    "createPoFailed": "Create PO failed",
    "selectQuotationFailed": "Failed to select quotation",
    "exportFailed": "Export failed",
    "orgContextRequired": "Organization context required",
    "requestLinkFailed": "Request link failed",
    "loadCatalogsFailed": "Failed to load catalogs",
    "inviteFailed": "Invite failed",
    "selectSupplierRfq": "Select at least one supplier",
    "addProductLineQuantity": "Add at least one product line with quantity",
    "setResponseDeadline": "Set a response deadline",
    "createRfqFailed": "Create RFQ failed",
    "loadVendorDashboardFailed": "Failed to load vendor dashboard",
    "loadRfqFailed": "Failed to load RFQ",
    "addQuotedProductLine": "Add at least one quoted product line",
    "submitQuotationFailed": "Submit quotation failed",
    "selectPurchaseOrder": "Select a purchase order",
    "addInvoiceLine": "Add at least one invoice line",
    "submitInvoiceFailed": "Submit invoice failed",
    "verificationFailed": "Verification failed",
    "createPurchaseRequestFailed": "Create purchase request failed",
    "loadMatchStatusFailed": "Failed to load match status",
    "threeWayMatchFailed": "Three-way match failed",
    "addProductLine": "Add at least one product line",
    "createVendorBillFailed": "Create vendor bill failed",
    "selectVendorBillId": "Select a valid vendor bill ID",
    "enterValidAmount": "Enter valid amount",
    "paymentPostingFailed": "Payment posting failed",
    "qcSubmissionFailed": "QC submission failed",
    "grnPostFailed": "GRN post failed",
    "autoReorderFailed": "Auto-reorder failed",
    "failedToLoadContracts": "Failed to load contracts",
    "failedToLoadGrns": "Failed to load GRNs",
    "failedToLoadPos": "Failed to load POs",
    "failedToLoadPurchaseRequests": "Failed to load purchase requests",
    "failedToLoadRfqs": "Failed to load RFQs",
    "failedToLoadVendorBills": "Failed to load vendor bills",
    "failedToLoadVendorPayments": "Failed to load vendor payments"
  },
  "labels": {
    "store": "Store *",
    "requiredByDate": "Required by date",
    "notes": "Notes",
    "reasonOrDeliveryInstructions": "Reason or delivery instructions",
    "rfq": "RFQ *",
    "supplier": "Supplier *",
    "deliveryDate": "Delivery date",
    "paymentTerms": "Payment terms",
    "purchaseRequestOptional": "Purchase request (optional)",
    "responseDeadline": "Response deadline *",
    "suppliers": "Suppliers *",
    "selectApprovedPurchaseRequest": "Select approved purchase request",
    "optionalInstructionsForSuppliers": "Optional instructions for suppliers",
    "vendorEmail": "Vendor email",
    "poOptional": "PO (optional)",
    "grnIdOptional": "GRN ID (optional)",
    "supplierInvoice": "Supplier invoice #",
    "billDate": "Bill date",
    "dueDate": "Due date",
    "vendorBill": "Vendor bill",
    "amount": "Amount",
    "selectVendorBill": "Select vendor bill",
    "warrantyTerms": "Warranty terms",
    "purchaseOrder": "Purchase order *",
    "supplierEmail": "Supplier email"
  },
  "formActions": {
    "createAndPostPayment": "Create + Post Payment"
  },
  "listActions": {
    "submitRequest": "Submit request",
    "runAutoReorder": "Run auto-reorder",
    "backToProcurement": "Back to procurement"
  },
  "reports": {
    "formats": {
      "csv": "CSV",
      "excel": "Excel",
      "pdf": "PDF"
    },
    "types": {
      "goodsReceipts": "Goods receipts",
      "purchaseOrders": "Purchase orders",
      "purchaseRequests": "Purchase requests",
      "rfqs": "RFQs",
      "spendAnalysis": "Spend analysis",
      "vendorBills": "Vendor bills"
    }
  }
}
